module.exports = __webpack_public_path__ + "a21ba59dc354ebcc4af78caf764a599e.png";